import CryptoJS from 'crypto-js'

export const PASSWORD_PATTERN = /^(?=.*[A-Z])(?=.*\d)[A-Z\d]{8,20}$/i

export function encryptPassword(password: string, isHash = true) {
  const localKey = import.meta.env.VITE_APP_PUBLIC_KEY || 'bestads'
  const key = CryptoJS.enc.Utf8.parse(localKey)
  const source = isHash ? CryptoJS.MD5(password).toString() : password
  const encrypted = CryptoJS.DES.encrypt(CryptoJS.enc.Utf8.parse(source), key, {
    iv: CryptoJS.enc.Utf8.parse(''),
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })

  return encrypted.ciphertext.toString().toUpperCase()
}
